/**
 * Плашка «Есть новая версия» — сверху, над вкладками и под листами.
 *
 * Закрыть её нельзя: старая версия может разойтись с сервером, и человеку
 * лучше обновиться. Но и сама она ничего не перезагружает — открытый лист с
 * недописанной операцией закрывает её собой, и решает человек.
 */
import { useEffect, useState } from 'react';
import { applyUpdate, onUpdateReady } from './sw-register.js';
import spark from './assets/brand/skoka-spark.svg';

export function UpdateBanner() {
  const [ready, setReady] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => onUpdateReady(setReady), []);
  if (!ready) return null;
  return (
    <div className="updbar" role="status">
      <img className="updspark" src={spark} width={22} height={23} alt="" />
      <div className="updtext">
        <b>Есть новая версия SKOKA</b>
        <span>Обнови — это пара секунд, все данные останутся на месте</span>
      </div>
      <button className="updbtn" disabled={busy} onClick={() => { setBusy(true); applyUpdate(); }}>
        {busy ? 'Обновляю…' : 'Обновить'}
      </button>
    </div>
  );
}
